import React, { useState } from "react"
import CustomButton from "../../components/custom-button/custom-button.component"
import { useMediaQuery, useTheme } from "@mui/material"

import * as S from "./home-hero.styles"
import FormPopup from "../../components/form-popup/form-popup.component"

const HomeHero = ({
  backgroundImage,
  topTitle,
  titleItems,
  description,
  button,
  image,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const [openForm, setOpenForm] = useState(false)

  const handleOpenForm = () => {
    setOpenForm(true)
  }
  const handleCloseForm = () => {
    setOpenForm(false)
  }
  const formattedItems = titleItems?.reduce((acc, curr, index) => {
    acc.push(curr.item)
    acc.push(800)
    return acc
  }, [])
  return (
    <S.Section>
      <S.BgImage img={backgroundImage}>
        <S.Wrapper maxWidth="xl">
          <S.TopTitle>{topTitle}</S.TopTitle>
          {/* <S.Title variant="h1">{title}</S.Title> */}
          <S.CustomTypeAnimation
            sequence={formattedItems}
            speed={10}
            deletionSpeed={40}
            wrapper="p"
            repeat={Infinity}
          />
          <S.Description>{description}</S.Description>
          <S.Button onClick={handleOpenForm} className="light">
            {button?.title}
          </S.Button>
          <S.Image img={image} />
        </S.Wrapper>
      </S.BgImage>
      <FormPopup open={openForm} handleClose={handleCloseForm} />
    </S.Section>
  )
}

export default HomeHero
